import React from "react"

const HealthCheck = () => {
    return(
        <h1>App is Working fine</h1>
    )
}

export default HealthCheck